import React, { Fragment } from "react"

import Sub from "~layout/sub"
import "./discovery-club.css"

const crumbs = [
    { text: "Discovery Club" },
]

const DiscoveryClubPage = () => {
    let content = (
        <Fragment>
            <div className="product-promotion_">
                <div className="product-brand_">
                    <img src={require('~images/discoveryclub/DC_logo@2x.png').default} className="img-responsive margin-auto branding-logo logo-md_ block" alt="Discovery Club | CommonTown" />
                    <ul className="dot-header-list_">
                        <li>Inspire Learning</li>
                        <li>Curate</li>
                        <li>Share</li>
                    </ul>
                </div>
                <div className="product-section_ section-fold-01_" id="section-01_">
                    <div className="section-content_ q-60p_">
                        <h2 className="section-title_">Quality Resources</h2>
                        <p>Thousands of curated teaching and learning materials -- more added monthly. Discover, customize, build and share your own collection with our AI-powered tools.</p>
                    </div>
                    <div className="section-image_">
                        <a className="product-plan_ discovery-cta_" href="https://discovery.club" target="_blank" rel="noopener noreferrer" title="Visit Discovery Club">
                            <div className="product-price_ discovery-cta-title_">
                                <span>Visit</span>
                            </div>
                            <div className="product-remarks_ discovery-cta-text_">
                                Discovery Club website
                            </div>
                            <div className="discovery-cta-button_">Go to Website</div>
                        </a>
                    </div>
                </div>
                <div className="product-section_ flex-row_ mascot-divider_" id="section-02_">
                   <h2 className="section-title_ text-center">Key Features</h2>
                   <div className="product-content_ half-layout_">
                        <div className="product-item_">
                            <div className="product-image_">
                                <img src={require('~images/discoveryclub/thousands of resources@3x.png').default} className="img-responsive margin-auto branding-logo block img-initial" alt="Thousands of Resources" />
                            </div>
                            <div className="product-summary_">
                                <h3>Thousands of Resources</h3>
                                <p>Dive into a treasure trove of fun, ready-to-use materials - pick, play, and share with your learners!</p>
                            </div>
                        </div>
                        <div className="product-item_">
                            <div className="product-image_">
                                <img src={require('~images/discoveryclub/ai matching@3x.png').default} className="img-responsive margin-auto branding-logo block img-initial" alt="AI Matching" />
                            </div>
                            <div className="product-summary_">
                                <h3>AI Matching</h3>
                                <p>Our clever AI spots each child's learning "sweet spot" and recommends just the right activities to spark joy and curiousity.</p>
                            </div>
                        </div>
                        <div className="product-item_">
                            <div className="product-image_">
                                <img src={require('~images/discoveryclub/drag and drop@3x.png').default} className="img-responsive margin-auto branding-logo block img-initial" alt="Drag and Drop" />
                            </div>
                            <div className="product-summary_">
                                <h3>Drag and Drop</h3>
                                <p>Teaching made easy! Simply drag and drop resources from your device or our libraries - it's quick and fun.</p>
                            </div>
                        </div>
                        <div className="product-item_">
                            <div className="product-image_">
                                <img src={require('~images/discoveryclub/pregress tracking@3x.png').default} className="img-responsive margin-auto branding-logo block img-initial" alt="Progress Tracking" />
                            </div>
                            <div className="product-summary_">
                                <h3>Progress Tracking</h3>
                                <p>See at a glance how your learners are learning and progressing.</p>
                            </div>
                        </div>
                        <div className="product-item_ full-width_">
                            <div className="product-image_">
                                <img src={require('~images/discoveryclub/create your own@3x.png').default} className="img-responsive block" alt="Create your own games & quizzes" />
                            </div>
                            <div className="product-summary_">
                                <h3>Create Your Own Games & Quizzes</h3>
                                <p>Need something unique? Instantly design your own games and test papers with our ready-made templates and flexible question types.</p>
                            </div>
                        </div>
                   </div>
                </div>
                <div className="product-section_ flex-column_" id="section-03_">
                    <div className="red-mascot_">
                         <img src={require('~images/discoveryclub/red@3x.png').default} className="img-responsive img-initial" alt="Mascot" />
                    </div>
                    <div className="speech-bubble_">
                        <span className="font-md_">Perfect for</span>
                        <h3>Kindergartens & Primary Schools</h3>
                        <span>Empowering teachers with curated exciting learning content</span>
                    </div>
                </div>
                <div className="product-section_ footer-section_ flex-column_" id="section-04_">
                    <div className="flex-row_ company-details_">
                         <img src={require('~images/discoveryclub/ct logo@3x.png').default} className="img-responsive block img-initial" alt="CommonTown" />
                         
                    </div>
                    <div className="flex-row_ sales-info_">
                        <ul>
                            <li>Contact us for partnership:</li>
                            <li className="icon-prefix_ icon-email_"><a href="mailto:partnership@commontown.com">partnership@commontown.com</a></li>
                         </ul>
                    </div>
                    <div className="flex-row_ sales-info_">
                         <ul>
                            <li>Contact us for a demo:</li>
                            <li className="icon-prefix_ icon-email_"><a href="mailto:biz@commontown.com">biz@commontown.com</a></li>
                         </ul>
                    </div>
                </div>
            </div>
        </Fragment>
    )

    return (
        <Sub title="Discovery Club" seo_name="Discovery Club" content={content} />
    )
}

export default DiscoveryClubPage
